import { createRepository } from './Repository'
import { DISABLE_AUTOPAYMENTS_URL } from '@/shared/api'

export interface DisableAutopaymentsSuccessResponse {
  success: true
}

export interface DisableAutopaymentsErrorResponse {
  detail: string
}

export type DisableAutopaymentsResponse = DisableAutopaymentsSuccessResponse | DisableAutopaymentsErrorResponse

const repository = createRepository({
  basePath: '', // Базовый путь пустой, так как DISABLE_AUTOPAYMENTS_PATH уже содержит путь от корня API
  useAuth: true
})

export const disableAutopaymentsRepository = {
  async disableAutopayments(): Promise<{ status: number; data: DisableAutopaymentsResponse }> {
    return repository.del<DisableAutopaymentsResponse>(
      DISABLE_AUTOPAYMENTS_URL,
      undefined,
      {
        401: 'Пользователь не авторизован',
        400: 'Некорректный запрос',
        403: 'Доступ запрещён',
        404: 'Метод отключения автоплатежей недоступен',
        500: 'Ошибка сервера при отключении автоплатежей'
      }
    )
  }
}